import type { ExploreScopeSelection } from "@/analytics/core/types";
import { parseScopeSelection, writeScopeSelection } from "@/analytics/core/scope-params";
import type { RawRepPickerMode } from "@/raw/lib/filter-by-scope";
import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export function useRawScopeParams(repPicker: RawRepPickerMode = "single-team") {
  const persistReps = repPicker === "always";
  const [searchParams, setSearchParams] = useSearchParams();

  const selection = useMemo(() => parseScopeSelection(searchParams), [searchParams]);

  const updateSelection = useCallback(
    (patch: ExploreScopeSelection) => {
      setSearchParams((current) => {
        const next = new URLSearchParams(current);
        writeScopeSelection(next, patch, { persistReps });
        return next;
      });
    },
    [persistReps, setSearchParams],
  );

  const setTeams = useCallback(
    (teamIds: number[]) => {
      updateSelection({
        teamIds,
        repIds: persistReps || teamIds.length === 1 ? selection.repIds : [],
      });
    },
    [persistReps, selection.repIds, updateSelection],
  );

  const setReps = useCallback(
    (repIds: number[]) => {
      updateSelection({
        teamIds: selection.teamIds,
        repIds,
      });
    },
    [selection.teamIds, updateSelection],
  );

  return { selection, setTeams, setReps };
}
